import { signOut } from '@citibox-panel/auth';

// The panel's only way out. It does not drain anything itself: the user-change handler empties the
// cache and the Google token when Firebase reports the sign-out, the same path expiry and other
// tabs take, so there is one draining path to trust.
export async function signOutOfPanel(): Promise<void> {
  await signOut();
  // eslint-disable-next-line no-console -- observability event, no identity attached
  console.info('[auth] signOut');
}
